import { Loader2 } from "lucide-react";

export function fmtAmerican(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  const v = Math.round(Number(n));
  return v > 0 ? `+${v}` : `${v}`;
}

export function fmtPct(n, sign = true) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  const v = Number(n);
  if (!sign) return `${v.toFixed(1)}%`;
  return v > 0 ? `+${v.toFixed(1)}%` : `${v.toFixed(1)}%`;
}

export function edgeToneClass(edgePct, edgeLabel) {
  if (edgeLabel === "+EV" || (Number.isFinite(edgePct) && edgePct >= 3)) {
    return "text-[#00D4FF]";
  }
  if (edgeLabel === "-EV" || (Number.isFinite(edgePct) && edgePct <= -3)) {
    return "text-red-400";
  }
  return "text-zinc-300";
}

export function dqTone(score) {
  const s = Number(score) || 0;
  if (s >= 70) return "text-[#00D4FF]";
  if (s >= 40) return "text-[#FFBF00]";
  return "text-red-400";
}

export function trapTone(score) {
  const s = Number(score) || 0;
  if (s >= 75) return "text-red-400";
  if (s >= 60) return "text-[#FFBF00]";
  return "text-zinc-400";
}

export function Cell({ children, className = "", testid }) {
  return (
    <td
      className={`px-3 py-2.5 mono text-xs border-b border-zinc-900 ${className}`}
      data-testid={testid}
    >
      {children}
    </td>
  );
}

export function HeadCell({ children, className = "" }) {
  return (
    <th
      scope="col"
      className={`px-3 py-2 overline text-left text-[9px] tracking-wider bg-zinc-950 border-b border-zinc-800 ${className}`}
    >
      {children}
    </th>
  );
}

export function EmptyState({ message, testid }) {
  return (
    <div
      className="border border-dashed border-zinc-800 p-10 text-center mono text-xs text-zinc-500"
      data-testid={testid}
    >
      {message}
    </div>
  );
}

export function LoadingRow({ cols = 8 }) {
  return (
    <tr>
      <td colSpan={cols} className="py-10 text-center mono text-xs text-zinc-500">
        <Loader2 size={16} className="inline animate-spin mr-2" />
        Loading tape…
      </td>
    </tr>
  );
}

export function StartTimeCell({ iso }) {
  if (!iso) return <span className="text-zinc-600">—</span>;
  const d = new Date(iso);
  const now = new Date();
  const deltaMin = Math.round((d - now) / 60000);
  const absolute = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  let relative;
  if (deltaMin < 0) relative = "live";
  else if (deltaMin < 60) relative = `${deltaMin}m`;
  else if (deltaMin < 1440) relative = `${Math.round(deltaMin / 60)}h`;
  else relative = `${Math.round(deltaMin / 1440)}d`;
  return (
    <div>
      <div className="text-zinc-200">{absolute}</div>
      <div className="text-[10px] text-zinc-500">{relative}</div>
    </div>
  );
}

export function MatchupCell({ row }) {
  return (
    <div className="min-w-0">
      <div className="text-zinc-200 truncate">{row.short_name || row.matchup}</div>
      <div className="text-[10px] text-zinc-500 uppercase mono">{row.sport}</div>
    </div>
  );
}
